'use client';
import styled, { keyframes, css } from 'styled-components';
import { ProductSelectionContainer } from '@web/components/ProductSelector/styles';
import { StyledStickyNav } from '@web/molecules/StickyNav/styles';

export const StyledForm = styled.form`
  padding-bottom: ${props => props.theme.spacing(15)};
  width: 100vw;

  @media ${props => props.theme.laptop} {
    padding-bottom: ${props => props.theme.spacing(0)};
  }
`;

export const StyledRecommendedPlanContainer = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${props => props.theme.colors.background.base};

  fieldset {
    border: none;
    margin: 0;
    padding: 0;
    min-width: unset;
  }

  @media ${props => props.theme.laptop} {
    flex-direction: row;
    justify-content: center;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  @media ${props => props.theme.laptop} {
    flex: 1;
    padding: ${props => props.theme.spacing(6, 16)};
    margin: ${props => props.theme.spacing(0)};
    align-items: flex-start;
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  top: 0;
  padding-top: ${props => props.theme.spacing(3)};
  color: ${props => props.theme.colors.text.primary};

  @media ${props => props.theme.laptop} {
    padding: ${props => props.theme.spacing(4, 0, 1)};
  }
`;

export const Headline = styled.h1`
  ${({ theme }) => theme.typography.body}
  text-align: left;
  margin: ${props => props.theme.spacing(0, 0, 3, 4)};

  @media ${({ theme }) => theme.tablet} {
    padding-left: 18vw;
  }
  @media ${({ theme }) => theme.laptop} {
    margin: ${props => props.theme.spacing(0, 1, 3)};
    padding-left: ${props => props.theme.spacing(0)};
  }
`;

export const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  margin: ${props => props.theme.spacing(0, 4)};

  @media ${({ theme }) => theme.laptop} {
    margin: 0;
  }
`;

export const FullSubheadline = styled.h1`
  ${({ theme }) => theme.typography.heading2}
  margin: ${props => props.theme.spacing(4, 0, 3)};
  text-align: left;
`;

export const ProductCardContainer = styled.div`
  max-width: 100%;
  margin: auto;
  text-align: center;

  @media ${({ theme }) => theme.laptop} {
    margin: 0;
  }
`;

export const PlanContainer = styled.div`
  margin: auto;
  margin-top: ${props => props.theme.spacing(3)};
  width: fit-content;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  ${props => props.theme.typography.heading4};
  padding-bottom: ${props => props.theme.spacing(10)};
  @media ${({ theme }) => theme.tablet} {
    margin-top: ${props => props.theme.spacing(5)};
    padding-bottom: ${props => props.theme.spacing(10)};
  }
`;

export const CarouselSectionContainer = styled.div`
  flex: 1;
  display: flex;
  align-content: center;
  justify-content: flex-end;
`;

export const DesktopImageContainer = styled.div`
  display: none;

  @media ${props => props.theme.laptop} {
    display: flex;
    width: 40vw;
    height: 40vw;
    max-height: 500px;
    max-width: 500px;
    margin: ${props => props.theme.spacing(10, 0, 0, 25)};
    img {
      object-fit: cover;
      min-height: 100%;
      width: 100%;
    }
  }
`;

export const MobileImageContainer = styled.div`
  margin: ${props => props.theme.spacing(4, 0, 0, 4)};
  margin-left: auto;
  overflow: hidden;
  width: 96vw;
  max-width: 96vw;

  img {
    height: 100%;
    max-width: 95vw;
    object-fit: cover;
  }
  @media ${props => props.theme.laptop} {
    display: none;
  }
`;

export const Description = styled.p`
  ${props => props.theme.typography.body};
  padding-bottom: ${props => props.theme.spacing(1)};
  text-wrap: wrap;
  text-align: left;

  @media ${({ theme }) => theme.laptop} {
    max-width: 65%;
    padding: ${props => props.theme.spacing(2, 0)};
  }
`;

export const SelectionText = styled.span`
  ${props => props.theme.typography.body};
  color: ${props => props.theme.colors.text.tertiary};
`;

export const StarRating = styled.div`
  margin-top: ${props => props.theme.spacing(3)};
  font-size: 18px;
  letter-spacing: 0.18px;
  &::before {
    letter-spacing: 2px;
    content: '★★★★★';
    background-color: ${props => props.theme.colors.secondary.plum};
    background-clip: text;
    /* stylelint-disable-next-line */
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`;

export const PricingContainer = styled.div`
  display: flex;
  margin: ${props => props.theme.spacing(2, 0, 4, 0)};
  font-size: 18px;
  gap: ${props => props.theme.spacing(1)};
`;

export const PriceBeforeDiscount = styled.p`
  color: #cab5aa;
  text-decoration-line: line-through;
`;

export const Price = styled.p`
  margin-left: ${props => props.theme.spacing(1)};
  font-weight: 600;
`;

export const DiscountAmount = styled.p`
  margin-left: ${props => props.theme.spacing(1)};
  color: ${props => props.theme.colors.status.successPrimary};
  font-weight: 600;
`;

export const FormSelsectionContainer = styled.fieldset`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;

  ${ProductSelectionContainer} {
    margin: 0px;
  }
`;

export const IconButtonContainer = styled.div`
  z-index: 101;
  display: flex;
  position: fixed;
  top: 10px;
  left: 10px;
  gap: ${props => props.theme.spacing(4)};
  max-width: 350px;
  width: 100%;

  button {
    border: none;
  }
  @media ${props => props.theme.laptop} {
    top: 10px;
    margin-bottom: ${props => props.theme.spacing(2)};
  }
`;

export const MixedDropdownContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing(4)};
`;

export const ContinueButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: ${props => props.theme.spacing(7, 0)};
  width: 100%;

  @media ${props => props.theme.laptop} {
    justify-content: flex-start;
    margin: ${props => props.theme.spacing(8, 0)};
    width: 320px;
  }
`;
export const CalloutsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin-bottom: ${props => props.theme.spacing(10)};

  @media ${props => props.theme.laptop} {
    justify-content: flex-start;
    max-width: 90%;
    margin: ${props => props.theme.spacing(2, 0, 8)};
  }
`;

export const CalloutContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing(2)};
  margin: ${props => props.theme.spacing(0, 4, 2, 0)};
`;

export const CallloutText = styled.p`
  ${props => props.theme.typography.body};
  text-wrap: nowrap;
  text-align: left;
`;

const slideDown = keyframes`
  from {
    transform: translateY(-20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;
const slideUp = keyframes`
  from {
    transform: translateY(0);
    opacity: 1;
  }
  to {
    transform: translateY(-20px);
    opacity: 0;
  }
`;

export const DesktopCheckoutBarContainer = styled.div`
  display: none;

  @media ${props => props.theme.laptop} {
    display: flex;

    ${StyledStickyNav} {
      animation: ${props =>
        props.$show
          ? css`
              ${slideDown} 0.3s ease-out forwards
            `
          : css`
              ${slideUp} 0.3s ease-out forwards
            `};
    }
  }
`;

const slideInUp = keyframes`
  from { transform: translateY(100%); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
`;

const slideOutDown = keyframes`
  from { transform: translateY(0); opacity: 1; }
  to { transform: translateY(100%); opacity: 0; }
`;

export const MobileCheckoutBarContainer = styled.div`
  display: flex;
  z-index: 1;

  ${StyledStickyNav} {
    animation: ${props =>
      props.$show
        ? css`
            ${slideInUp} 0.3s ease-out forwards
          `
        : css`
            ${slideOutDown} 0.3s ease-out forwards
          `};
  }

  @media ${props => props.theme.laptop} {
    display: none;
  }
`;
